import SelectionState from "state/selections/SelectionState";
import { titleCase } from "@ls/js-utils";
import { EntityType } from "@ls/entity-service";
import { selectDefinitions, selectEntityAttributes } from "./selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const entityAttributes = useSelector(selectEntityAttributes);
  const dispatch = useDispatch();

  const getDefaultColumnDef = React.useCallback(
    (attribute) => {
      switch (attribute) {
        case "name":
          return {
            X_formatType: "TEXT",
            valueGetter: ({ data }) => {
              if (data) {
                return data.type === EntityType.BMARK
                  ? data.longName || data.name
                  : data.name;
              }
            },
          };
        case "repAccount":
          return {
            filter: "agSetColumnFilter",
            X_formatType: 'TEXT',
            valueGetter: ({ data = {} }) => {
              return data.repAccount ? "Y" : "N";
            },
          };
        case "assetClassId":
          return {
            X_formatType: "NUMBER",
            X_decimal: 0,
          };
        case "sourceEntityId":
        case "entityId":
        case "major":
        case "managerId":
        case "managerLastName":
        case "managerFirstName":
        case "minor":
          return {
            X_formatType: "TEXT",
          };
        case "productDescription":
          return {
            filter: "agSetColumnFilter",
          };
        case "allowsFutures":
        case "allowsIsda":
        case "buyAndMaintain":
        case "hedged":
        case "lookthru":
        case "majorOnlyReporting":
        case "natixisMapAdvised":
        case "paperPortfolio":
        case "perfProxyAcct":
        case "stableValue":
          return {
            filter: "agSetColumnFilter",
            X_formatType: "TEXT",
            valueGetter: ({ data = {} }) => {
              return data[attribute] ? "true" : "false";
            },
          };
        case "acId":
          return {
            X_formatType: "TEXT",
            headerName: "ACID",
          };
        case "benchmarkName":
          return {
            valueGetter: ({ data = {} }) => {
              const entity = entityAttributes.find(
                ({ entityId }) => entityId === data.benchmarkId
              );
              return entity?.longName ?? entity?.name ?? ""; //if bmk is actually a bnehcmark, "longName" is popoulated. if it's acc, "name" is populated
            },
          };
        default:
          return {};
      }
    },
    [entityAttributes]
  );

  return React.useMemo(() => {
    return definitions.map((definition) => {
      return {
        headerName: titleCase(definition.attribute),
        field: definition.attribute,
        colId: definition.attribute,
        X_onDelete: () => dispatch(deleteColumn(definition)),
        ...getDefaultColumnDef(definition.attribute),
      };
    });
  }, [definitions, dispatch, getDefaultColumnDef]);
};
